
import React from 'react';
import { Users, CreditCard, Award, TrendingUp } from 'lucide-react';
import StatItem from './StatItem';
import { Referral } from '@/components/ReferralList';
import { calculateReferralStats } from '../utils/statisticsUtils';

interface DashboardStatisticsComponentProps {
  referrals: Referral[] | undefined;
  points: number;
}

const DashboardStatisticsComponent: React.FC<DashboardStatisticsComponentProps> = ({ 
  referrals, 
  points 
}) => {
  const { totalReferrals, pendingReferrals, approvedReferrals, successRate } = calculateReferralStats(referrals);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatItem 
        title="Total Referrals" 
        value={totalReferrals} 
        icon={<Users className="h-5 w-5" />}
        description="All-time referrals sent"
        className="bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200"
        iconClassName="bg-blue-500 text-white"
      />
      <StatItem 
        title="Available Points" 
        value={points.toLocaleString()} 
        icon={<CreditCard className="h-5 w-5" />}
        description="Points ready to redeem"
        className="bg-gradient-to-br from-purple-50 to-purple-100 hover:from-purple-100 hover:to-purple-200"
        iconClassName="bg-purple-500 text-white"
      />
      <StatItem 
        title="Successful Referrals" 
        value={approvedReferrals} 
        icon={<Award className="h-5 w-5" />}
        description="Converted to customers"
        className="bg-gradient-to-br from-green-50 to-green-100 hover:from-green-100 hover:to-green-200"
        iconClassName="bg-green-500 text-white"
      />
      <StatItem 
        title="Success Rate" 
        value={`${successRate}%`} 
        icon={<TrendingUp className="h-5 w-5" />}
        description="Conversion percentage"
        className="bg-gradient-to-br from-amber-50 to-amber-100 hover:from-amber-100 hover:to-amber-200"
        iconClassName="bg-amber-500 text-white"
      />
    </div>
  );
};

export default DashboardStatisticsComponent;
